import { useCalendarOpened } from '~/stores/calendar/state'
import { Calendar } from './Calendar'
import { MealPeriodTab } from './MealPeriodTab'
import { Selection } from './Selection'
import { VisitDate } from './VisitDate'

export function VisitDateCalendar({ hideMealPeriodTab = false }: { hideMealPeriodTab?: boolean }) {
  const showCalendar = useCalendarOpened()
  return showCalendar ? (
    <div className="space-y-3">
      {!hideMealPeriodTab && <MealPeriodTab />}
      <Calendar />
    </div>
  ) : (
    <Selection label="日付">
      <VisitDate />
    </Selection>
  )
}
